import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  documentDesigner: {
    description: 'Header for the page',
    defaultMessage: 'Pick Lists',
    id: '7OrSXo',
  },
  saveTemplate: {
    description: 'Save button text for saving the template',
    defaultMessage: 'Save',
    id: 'STZ73/',
  },
  resetToDefault: {
    description: 'Button text for resetting template to default',
    defaultMessage: 'Load Default',
    id: 'xWKv+U',
  },
  deleteWidgetHotkey: {
    description: 'Hotkey name for deleting selected widget in document designer',
    defaultMessage: 'Delete Widget',
    id: '3VTuAU',
  },
  undo: {
    description: 'Button text for undo action',
    defaultMessage: 'Undo',
    id: 'Hr2pfJ',
  },
  redo: {
    description: 'Button text for redo action',
    defaultMessage: 'Redo',
    id: 'srIGve',
  },
});
